module.exports = __webpack_public_path__ + "img/559.73cabc41.jpg";